import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom';
import Header from './components/header/header';
import InventoryPage from './components/inventory-page/inventory-page';
import ProjectPage from './components/projects-page/projects-page';
import ShoppingPage from './components/shopping-page/shopping-page';
import { useStoreActions, useStoreState } from './store/data-store';
import { DataService } from './services/data-service';
import ProjectDetailsPage from './components/project-details-page/project-details-page';
import LoginPage from './components/login-page/login-page';
import WelcomePage from './components/welcome-page/welcome-page';

const StitchBean = () => {

    const setInventory = useStoreActions(store => store.setInventory);
    const setColours = useStoreActions(store => store.setColours);
    const isLoggedIn = useStoreState(store => store.isLoggedIn)
    const user = useStoreState(store => store.user);

    useEffect(() => {
        async function loadInventory(){
            const dataService = new DataService();
            var tokens = await dataService.getAccessToken(user);
            var inventory = await dataService.getInventory(user.id, tokens.accessToken);
            var colours = await dataService.getColours();
            setInventory(inventory);
            setColours(colours);
        };
        if( isLoggedIn ){
            loadInventory();
        }

    }, [isLoggedIn])

    return (
        <div>
            <Header />
            <Routes>
                <Route path="/" element ={<WelcomePage/>}/>
                <Route path="/login" element={<LoginPage/>}/>
                <Route path="/projects" element={<ProjectPage />} />
                <Route path="/projects/:projectId" element={<ProjectDetailsPage/>}/>
                <Route path="/inventory" element={<InventoryPage />} />
                <Route path="/shopping" element={<ShoppingPage />} />
            </Routes>
        </div>
    )

}
export default StitchBean